import "@nim-os/in2-app-talk";
import React from "react";
import {render} from 'react-dom';
import "@ls/ls-style";
import App from "./App";
import { Provider as StoreProvider } from "react-redux";
import { UserProvider, LegacyAuthProvider } from "@ls/user-module";
import DateProvider from "@ls/date-module";
import store from "state/store";
import { ErrorBoundary } from "@ls/error-module";
import { PromptProvider } from "@ls/react-prompt";
import { Provider as ToastProvider } from "@ls/react-toast";
import { ThemeProvider } from "@ls/ls-style";
import { QueryClientProvider } from "react-query";
import { DistributionProvider } from "@ls/distribution";
import { PersistenceProvider } from "@ls/persistence-module";
import {
  EntityServiceProvider,
  EntityServiceBaseURL,
} from "@ls/entity-service";
//import { DistributionProvider } from "@ls/distribution";

import {
  EntityMappingServiceProvider,
  EntityMappingServiceBaseURL,
} from "@ls/entity-mapping-service";
import { setFetcher } from "@ls/js-fetch";
import { queryClient } from "./queryClient";

const ReactQueryDevtools =
  process.env.NODE_ENV === "development"
    ? require("react-query/devtools").ReactQueryDevtools
    : null;

if (process.env.NODE_ENV === "development") {
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React);
}

const appId = process.env.REACT_APP_ID;
const env = process.env.REACT_APP_IN2_ENV;

// Azure host environment validation and setup
if (
  process.env.REACT_APP_HOST_ENV === "AZURE" &&
  !process.env.REACT_APP_ALLOWED_TENANT_IDS
) {
  throw new Error("REACT_APP_ALLOWED_TENANT_IDS is not defined");
}

const allowedTenantIds = process.env.REACT_APP_ALLOWED_TENANT_IDS?.split(
  ","
).map((tid) => tid.trim());

const hostEnv = process.env.REACT_APP_HOST_ENV;
console.log("process.env.REACT_APP_HOST_ENV", hostEnv);
const AppContainer = () => {
  // Choose auth provider based on host env
  let Auth;
  if (process.env.REACT_APP_HOST_ENV === "AZURE") {
    Auth = function Auth(props) {
      return (
        <UserProvider allowedTenantIds={allowedTenantIds} setFetcher={setFetcher}>
          {props.children}
        </UserProvider>
      );
    };
  } else {
    Auth = function Auth(props) {
      return <LegacyAuthProvider>{props.children}</LegacyAuthProvider>;
    };
  }
  return (
    <QueryClientProvider client={queryClient}>
      <Auth>
      <DistributionProvider>
        <StoreProvider store={store}>
          <ErrorBoundary>
            <ThemeProvider>
              <EntityServiceProvider 
                appId={appId} 
                baseURL={process.env.REACT_APP_BASE_URL_ENTITY_SERVICE}>
                <EntityMappingServiceProvider 
                  appId={appId} 
                  baseURL={process.env.REACT_APP_BASE_URL_ENTITY_MAPPING}>
                    <PersistenceProvider appId={process.env.REACT_APP_ID}>
                      <DateProvider                           
                          appId={appId}
                          baseURL={
                            process.env.REACT_APP_BASE_URL_ENTITY_SERVICE
                          }
                          >
                        <PromptProvider>
                          <ToastProvider>
                            <App />                      
                          </ToastProvider>
                        </PromptProvider>
                      </DateProvider>
                    </PersistenceProvider>
                </EntityMappingServiceProvider>
              </EntityServiceProvider>
            </ThemeProvider>
          </ErrorBoundary>
        </StoreProvider>
      </DistributionProvider>
      </Auth>
      {ReactQueryDevtools ? <ReactQueryDevtools initialIsOpen={false} /> : null}
    </QueryClientProvider>)
}

render(
  <AppContainer/>,
  document.getElementById('root')
)

/*
const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<AppContainer />);
*/

if (process.env.REACT_APP_IN2_ENV !== "PRD") {
  const el = document.createElement("span");
  el.appendChild(document.createTextNode(process.env.REACT_APP_IN2_ENV));
  el.setAttribute(
    "style",
    "color:#929938;position:fixed;z-index:100;bottom:2px;left:2px;font-size:1.5em;font-weight:bold;"
  );
  el.setAttribute("id", "env-warn");
  document.body.insertBefore(el, document.getElementById("root"));
}
